export const CURRENCY_SIGN = 'zł'
